import { DiscoveryApi, FetchApi } from "@backstage/core-plugin-api";
import { ResponseError } from '@backstage/errors';
import { PlatformVersionServiceEntry } from "@internal/plugin-platform-version-common";
import { PlatformServiceVersionApi } from "./api";




export class DefaultPlatformServiceVersionApi implements PlatformServiceVersionApi {

    private readonly discoveryApi: DiscoveryApi;
    private readonly fetchApi: FetchApi;

    public constructor(options: {
        discoveryApi: DiscoveryApi;
        fetchApi: FetchApi;
    }) {
        this.discoveryApi = options.discoveryApi;
        this.fetchApi = options.fetchApi;
    }

    private async fetch<T = unknown | string>(
        path: String
    ): Promise<T | String> {
        const url = await this.discoveryApi.getBaseUrl('platform-version');
        const resp = await this.fetchApi.fetch(`${url}${path}`);
        if (!resp.ok) {
            throw await ResponseError.fromResponse(resp);
        }
        if (resp.headers.get('content-type')?.includes('application/json')) {
            return await resp.json();
        }
        return await resp.text();
    }

    async loadByComponentName(id: String): Promise<PlatformVersionServiceEntry> {
        return (await this.fetch<PlatformVersionServiceEntry>(
            `/component?entity=${id}`
        )) as PlatformVersionServiceEntry
    };


    async loadForAllServices(): Promise<PlatformVersionServiceEntry[]> {
        return (await this.fetch<PlatformVersionServiceEntry[]>(
            '/'
        ) as PlatformVersionServiceEntry []);
    };

}